export class AppConfig {
  public static API_URL = "https://api.farmashopper.360bvm.net";
  // public static API_URL = 'http://127.0.0.1:3241';
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts